import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TokenStorageService } from '../_services/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class CallService {

  constructor(private tokenStorage: TokenStorageService) { }

  getHTTPOptionWithOrWithoutConnected() {
    var $return = this.getHTTPOptionWithoutToken();
    if(this.tokenStorage.getUser() && this.tokenStorage.getUser().token) {
      $return = this.getHTTPOptionWithToken();
    }
    return $return;
  }

  getHTTPOptionWithoutToken() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json'})
    };
    return httpOptions;
  }

  getHTTPOptionWithToken() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.tokenStorage.getUser().token}`, 'Accept': '*/*' })
    };
    return httpOptions;
  }
}
